import { render, staticRenderFns } from "./permissionTree.vue?vue&type=template&id=c94f9e42&scoped=true"
import script from "./permissionTree.vue?vue&type=script&lang=js"
export * from "./permissionTree.vue?vue&type=script&lang=js"
import style0 from "./permissionTree.vue?vue&type=style&index=0&id=c94f9e42&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94f9e42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c94f9e42')) {
      api.createRecord('c94f9e42', component.options)
    } else {
      api.reload('c94f9e42', component.options)
    }
    module.hot.accept("./permissionTree.vue?vue&type=template&id=c94f9e42&scoped=true", function () {
      api.rerender('c94f9e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/positionManage/components/permissionTree.vue"
export default component.exports